export default __webpack_public_path__ + "static/media/zawodnik3.150b7091.png";